/**
 * Servicio para tracking de tiempo de interacción
 * Basado en ReadTime.cs
 */

import configService from './configService';

export interface TimeData {
  id: string;
  available: boolean;
  created: string;
  modified: string;
  assistant_id: string;
  email: string;
  time: number;
}

export class InteractionTimeService {
  private startTime: number = 0;
  private initTime: number = 0;
  private updateTimeID: string | null = null;
  private timeElapse: number = 0;

  /**
   * Inicializar tiempo de interacción
   */
  async initialize(): Promise<void> {
    this.startTime = Date.now() / 1000; // Convertir a segundos

    try {
      const config = configService.getConfig();
      // Si no hay email, no podemos obtener tiempo
      if (!config.email) {
        console.warn('No hay email disponible para obtener tiempo');
        return;
      }
      // Si no hay accessToken pero hay email, continuar sin obtener tiempo inicial desde API
      // (el tiempo se calculará localmente)
      if (!config.accessToken) {
        console.warn('No hay token disponible para obtener tiempo inicial desde API, usando tiempo local');
        return;
      }

      // Obtener tiempo inicial desde API
      const timeData = await this.getTimeFromAPI(config.email, config.accessToken);
      
      if (timeData) {
        this.updateTimeID = timeData.id;
        this.initTime = timeData.time;
      } else {
        // Crear nuevo registro de tiempo
        await this.createTimeRecord(config.assistantID, config.email);
      }
    } catch (error) {
      console.error('Error al inicializar tiempo:', error);
    }
  }

  /**
   * Obtener tiempo desde API
   * NOTA: Esta funcionalidad ha sido deshabilitada - ya no se hacen llamadas a mentoraibot.com
   */
  private async getTimeFromAPI(_email: string, _token: string): Promise<TimeData | null> {
    // Funcionalidad deshabilitada - ya no se hacen llamadas a mentoraibot.com
    return null;
  }

  /**
   * Crear nuevo registro de tiempo
   * NOTA: Esta funcionalidad ha sido deshabilitada - ya no se hacen llamadas a mentoraibot.com
   */
  private async createTimeRecord(_assistantID: string, _email: string): Promise<void> {
    // Funcionalidad deshabilitada - ya no se hacen llamadas a mentoraibot.com
  }

  /**
   * Obtener tiempo transcurrido
   */
  getTimeElapsed(): number {
    const currentTime = Date.now() / 1000;
    this.timeElapse = this.initTime + (currentTime - this.startTime);
    return Math.floor(this.timeElapse);
  }

  /**
   * Obtener tiempo en formato horas:minutos
   */
  getTimeFormatted(): string {
    const totalSeconds = this.getTimeElapsed();
    const horas = Math.floor(totalSeconds / 3600);
    const minutos = Math.floor((totalSeconds - horas * 3600) / 60);
    return `${horas.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')}`;
  }

  /**
   * Actualizar tiempo en servidor
   * NOTA: Esta funcionalidad ha sido deshabilitada - ya no se hacen llamadas a mentoraibot.com
   */
  async updateTime(): Promise<void> {
    // Funcionalidad deshabilitada - ya no se hacen llamadas a mentoraibot.com
  }

  getUpdateTimeID(): string | null {
    return this.updateTimeID;
  }
}

export const interactionTimeService = new InteractionTimeService();
export default interactionTimeService;


